<script>
    /* Imports */
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    

    /* Props komponenty DateInput */
    // export let format = {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    // };
    export let date = new Date();
    export let required = false;
    export let id = "date-input";
    export let labelTitle = "Vyberte datum:";
    export let styleOutside = "";
    export let styleInside = "";

    /* Vlastnosti komponenty DateInput */
    let internalValue;
    
    const dispatch = createEventDispatcher();

    /* Funkce komponenty DateInput */

    const input = (x) => {
        internalValue = new Date(x.getTime() - (x.getTimezoneOffset() * 60000 ))
                    .toISOString()
                    .split("T")[0];;
    }

    const output = (x) => {
        date = new Date(x);
        dispatch('change');
    }

    $: input(date);
    $: output(internalValue);
</script>

<div style={styleOutside}>
    <label for="date-input-{id}">{labelTitle}</label>
    <input type="date" id="date-input-{id}" name="date-input-{id}" {required} bind:value={internalValue} style={styleInside}/>
</div>

<style>

</style>